import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataCommissionRecipient } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_COMMISSION_RECIPIENT =
  defineMasterdataEntity<MasterdataCommissionRecipient>({
    name: 'commission-recipient',
    responseKey: 'commissionRecipients',
    displayWith: (c) => keyName(c.key, c.name),
    defaultFilter: ACTIVE_ONLY,
    icon: 'fa-regular fa-badge-percent',
    title: 'Provisionärsuche',
    label: 'Provisionär',
    placeholder: 'Provisionär suchen...',
    columns: [
      {
        label: 'Provisionär',
        type: 'entity',
        icon: 'fa-regular fa-badge-percent',
        value: (e) => keyName(e.key, e.name),
      },
      { label: 'Schlüssel', value: (e) => e.key },
      { label: 'Bezeichnung', value: (e) => e.name },
      { label: 'Aktiv', value: (e) => (e.active ? 'Ja' : 'Nein') },
    ],
  });
